import React, { useState, useRef, useEffect } from 'react';
import './addproduct.css';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import AddBrandModal from './components/Modals/AddBrandModal';
import AddUnitModal from './components/Modals/AddUnitModal';
import AddCategoryModal from './components/Modals/AddCategoryModal';

import 'react-datepicker/dist/react-datepicker.css';
import apiService from './services/api';
import { useLocation, useNavigate } from 'react-router-dom';

const barcodeTypes = [
  'Code 128 (C128)',
  'Code 39 (C39)',
  'EAN-13',
  'EAN-8',
  'UPC-A',
  'UPC-E'
];

const units = [
  'Pieces (Pc(s))',
  'Single (Single)',
  '12 Bottle Case (12 Bottle)',
  '24 PK Case (24 Pk Case)',
  '2 Pk Case (2 Pk Case)',
  '6pk Bottle (6pk Bottle)',
  'Beer Case (Case)'
];

const categories = [
  'All Lotto', 'BEER-41', 'BOURBON-20', 'BOURBONS', 'BRANDY-2', 'CANADIAN-35',
  'CANDY (SUGAR)', 'CANNABIS-83', 'CIGARETTES-5', 'CIGARS-4', 'COGNAC-44',
  'CORDIALS & LIQUEURS-48', 'CRAFT beer 8.5%', 'CRAFT BEER-43', 'CREME DE CACAO-60',
  'DRINKS-51', 'GIN-51', 'GROCERY-73', 'IMPORTED WINE-3', 'IRISH WHISKEY-22',
  'JUICE, WATER, NON-SUGAR, POWDERED MIXES-93', 'LIQUEUR-11', 'LIQUEURES & CORDIALS-33',
  'LIQUOR-23', 'Lotto Payout-106', 'Lotto Sale-105', 'Lotto-109', 'MALT BASED COOLERS-47',
  'MINIATURES-28', 'MISC', 'MIXERS-8', 'Online Lottery', 'Online Payout', 'PHILLIPS & KING-98',
  'PREMIUM SPIRITS-103', 'PREMIXED DRINKS-26', 'RTD COCKTAILS-42', 'RUM-34', 'SCHNAPPS-17',
  'SCOTCH-29', 'SINGLE BEER-30', 'SNACKS-69', 'SNACKS, FOOD, SPICES-94', 'SPARKLING WINE-37',
  'SPIRITS CENTRAL-75', 'SPIRITS GLAZERS-76', 'SPIRITS MOON-81', 'SPIRITS-91', 'STRAIGHT BOURBON-59',
  'STRAIGHT RYE-62', 'SUGAR DRINKS-95', 'TEQUILA-12', 'TOBACCO-53', 'US WINE-6', 'VERMOUTH-49',
  'VODKA-46', 'WHISKEY', 'WHISKY-70', 'WINE CENTRAL-99', 'WINE MOON-80', 'WINE-36'
];

const taxOptions = [
  'None', 'beer Tax', 'food', 'Wine and Liquor 10.5%', 'NoTax', 'Sales Tax', 'CIGARETTES'
];



export default function AddProduct({ onSuccess, isModal }) {
  const location = useLocation();
  const navigate = useNavigate();
  const onClose = () => {
    if (onSuccess) {
      onSuccess();
    } else {
      navigate('/products');
    }
  };
  const editProduct = location?.state?.editProduct;
  const isEditMode = Boolean(editProduct && editProduct.id);
  const [formData, setFormData] = useState({
    productName: '',
    sku: '',
    barcodeType: 'Code 128 (C128)',
    unit: '',
    brand: '',
    category: '',
    subcategory: '',
    businessLocation: "Lefty'S Liquor (BL0001)",
    alertQuantity: '',
    manageStock: true,
    enableDescription: false,
    notForSelling: false,
    weight: '',
    preparationTime: '',
    disableWoocommerceSync: false,
    applicableTax: 'None',
    sellingPriceTaxType: 'inclusive',
    productType: 'Single',
    defaultPurchasePrice: '',
    margin: '',
    defaultSellingPrice: '',
    description: '',
    image: null,
    brochure: null,
    purchasePriceEx: '',
    purchasePriceIn: '',
    sellingPrice: '',
    caseQty: '',
    casePrice: '',
  });

  const [activeSection, setActiveSection] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submittingAction, setSubmittingAction] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [brochureName, setBrochureName] = useState('');
  const [brochurePreview, setBrochurePreview] = useState(null);
  const [brochureText, setBrochureText] = useState('');
  const [showUnitModal, setShowUnitModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [showBrochureModal, setShowBrochureModal] = useState(false);
  const [imageZoom, setImageZoom] = useState(1);
  const [brochureZoom, setBrochureZoom] = useState(1);
  const topRef = useRef(null);

  // Opening Stock state
  const [showOpeningStock, setShowOpeningStock] = useState(false);
  const [openingStockRows, setOpeningStockRows] = useState([]);

  const handleShowOpeningStock = () => {
    setOpeningStockRows([{ id: Date.now(), qty: '', cost: formData.purchasePriceEx || '', date: '', note: '' }]);
    setShowOpeningStock(true);
  };

  const handleAddOpeningStockRow = () => {
    setOpeningStockRows(prev => [...prev, { id: Date.now(), qty: '', cost: formData.purchasePriceEx || '', date: '', note: '' }]);
  };

  const handleRemoveOpeningStockRow = (id) => {
    setOpeningStockRows(prev => prev.filter(r => r.id !== id));
  };

  const updateOpeningStockRow = (id, field, value) => {
    setOpeningStockRows(prev => prev.map(r => r.id === id ? { ...r, [field]: value } : r));
  };


  // API-fetched metadata lists — each item is { id, name, ... }
  const [unitsList, setUnitsList] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [brandsList, setBrandsList] = useState([]);
  const [taxRatesList, setTaxRatesList] = useState([]);

  // Fetch dropdowns from API on mount
  useEffect(() => {
    const loadMetadata = async () => {
      try {
        const [unitData, catData, brandData, taxData] = await Promise.all([
          apiService.getUnits().catch(() => ({ data: [] })),
          apiService.getCategories().catch(() => ({ data: [] })),
          apiService.getBrands().catch(() => ({ data: [] })),
          apiService.getTaxRates ? apiService.getTaxRates().catch(() => []) : Promise.resolve([]),
        ]);
        setUnitsList(Array.isArray(unitData) ? unitData : (unitData.data || []));
        setCategoriesList(Array.isArray(catData) ? catData : (catData.data || []));
        setBrandsList(Array.isArray(brandData) ? brandData : (brandData.data || []));
        setTaxRatesList(Array.isArray(taxData) ? taxData : (taxData.data || []));
      } catch (err) {
        console.error('Failed to load form metadata:', err);
      }
    };
    loadMetadata();
  }, []);

  useEffect(() => {
    if (!isEditMode) return;

    // Map product from products table to AddProduct form shape.
    setFormData(prev => {
      const cost = Number(editProduct.cost ?? 0);
      const price = Number(editProduct.price ?? 0);
      const margin = cost > 0 ? (((price - cost) / cost) * 100) : '';

      return {
        ...prev,
        productName: editProduct.name || '',
        sku: editProduct.sku || '',
        category: editProduct.category || '',
        brand: editProduct.brand && editProduct.brand !== 'N/A' ? editProduct.brand : prev.brand,
        unit: editProduct.unit || prev.unit,
        productType: editProduct.type ? String(editProduct.type).toLowerCase() === 'single' ? 'Single' : editProduct.type : prev.productType,
        applicableTax: editProduct.tax || prev.applicableTax,
        businessLocation: editProduct.location || prev.businessLocation,
        notForSelling: Boolean(editProduct.notForSelling),
        description: editProduct.description || '',
        purchasePriceEx: cost ? cost.toFixed(2) : '',
        sellingPrice: price ? price.toFixed(2) : '',
        margin: margin === '' ? '' : Number(margin).toFixed(2),
      };
    });

    if (editProduct.image && typeof editProduct.image === 'string') {
      setImagePreview(editProduct.image);
    }
  }, [editProduct, isEditMode]);

  // Brand Modal State
  const [showBrandModal, setShowBrandModal] = useState(false);
  const [brands, setBrands] = useState([]);

  const handleAddBrand = (newBrand) => {
    const brandOption = { id: newBrand.id || `tmp_${Date.now()}`, name: newBrand.name };
    setBrands(prev => [...prev, brandOption]);
    setFormData(prev => ({ ...prev, brand_id: brandOption.id }));
  };

  const handleAddUnit = (unitData) => {
    const unitOption = { id: unitData.id || `tmp_${Date.now()}`, name: `${unitData.name} (${unitData.shortName || ''})` };
    setUnitsList(prev => [...prev, unitOption]);
    setFormData(prev => ({ ...prev, unit_id: unitOption.id }));
    setShowUnitModal(false);
  };

  const [showCategoryModal, setShowCategoryModal] = useState(false);

  const handleAddCategory = (catData) => {
    const catOption = { id: catData.id || `tmp_${Date.now()}`, name: catData.name };
    setCategoriesList(prev => [...prev, catOption]);
    if (catData.add_as_sub_cat && catData.parent_id) {
      setFormData(prev => ({ ...prev, subcategory: catOption.id })); // assuming subcategory acts like this
    } else {
      setFormData(prev => ({ ...prev, category_id: catOption.id }));
    }
    setShowCategoryModal(false);
  };

  // Variation groups state for Variable product type
  const [variationGroups, setVariationGroups] = useState([
    { name: 'Size', values: [{ name: '', dpp: '', dppIncTax: '', margin: '30', dsp: '', dspIncTax: '' }] }
  ]);
  // Combo items state for Combo product type
  const [comboItems, setComboItems] = useState([]);
  const [comboSearchResults, setComboSearchResults] = useState([]);
  const [showComboDropdown, setShowComboDropdown] = useState(null);
  const [isSearchingCombo, setIsSearchingCombo] = useState(false);

  const addVariationGroup = () => {
    setVariationGroups(prev => [
      ...prev,
      { name: '', values: [{ name: '', dpp: '', dppIncTax: '', margin: '30', dsp: '', dspIncTax: '' }] }
    ]);
  };

  const removeVariationGroup = (gi) => {
    setVariationGroups(prev => prev.filter((_, i) => i !== gi));
  };

  const addVariationValue = (gi) => {
    setVariationGroups(prev => prev.map((g, i) => i !== gi ? g : {
      ...g,
      values: [...g.values, { name: '', dpp: '', dppIncTax: '', margin: '30', dsp: '', dspIncTax: '' }]
    }));
  };

  // Synchronize Combo total prices to formData
  useEffect(() => {
    if (formData.productType === 'Combo' && comboItems.length > 0) {
      const totalCost = comboItems.reduce((sum, item) => sum + (parseFloat(item.qty) || 0) * (parseFloat(item.cost) || 0), 0);
      const totalSell = comboItems.reduce((sum, item) => sum + (parseFloat(item.qty) || 0) * (parseFloat(item.price) || 0), 0);

      setFormData(prev => {
        const taxRate = getTaxRate();
        const taxType = prev.sellingPriceTaxType;

        // totalSell from combo components is usually inclusive (sell_price_inc_tax)
        let sellIn = totalSell;
        let sellEx = totalSell / (1 + taxRate);

        return {
          ...prev,
          purchasePriceEx: totalCost > 0 ? totalCost.toFixed(2) : prev.purchasePriceEx,
          purchasePriceIn: totalCost > 0 ? (totalCost * (1 + taxRate)).toFixed(2) : prev.purchasePriceIn,
          sellingPrice: totalSell > 0 ? (taxType === 'Inclusive' ? sellIn.toFixed(2) : sellEx.toFixed(2)) : prev.sellingPrice,
          margin: totalCost > 0 && totalSell > 0 ? (((sellEx - totalCost) / totalCost) * 100).toFixed(2) : prev.margin
        };
      });
    }
  }, [comboItems, formData.productType, formData.sellingPriceTaxType, formData.applicableTax]);

  const removeVariationValue = (gi, vi) => {
    setVariationGroups(prev => prev.map((g, i) => i !== gi ? g : {
      ...g, values: g.values.filter((_, j) => j !== vi)
    }));
  };

  const updateVariationGroup = (gi, field, val) => {
    setVariationGroups(prev => prev.map((g, i) => i !== gi ? g : { ...g, [field]: val }));
  };

  const updateVariationValue = (gi, vi, field, val) => {
    setVariationGroups(prev => prev.map((g, i) => i !== gi ? g : {
      ...g,
      values: g.values.map((v, j) => {
        if (j !== vi) return v;
        const updated = { ...v, [field]: val };
        const tax = getTaxRate();
        const taxType = formData.sellingPriceTaxType.toLowerCase();

        // Auto-calc Inc. tax and sell price
        if (field === 'dpp') {
          const num = parseFloat(val) || 0;
          updated.dppIncTax = num > 0 ? (num * (1 + tax)).toFixed(2) : '';
          const m = parseFloat(updated.margin) || 30;

          // Calculate sell prices
          const sellEx = num * (1 + m / 100);
          const sellIn = sellEx * (1 + tax);

          // Logic: dsp in state is the value for column 1
          updated.dsp = taxType === 'inclusive' ? sellIn.toFixed(2) : sellEx.toFixed(2);
          updated.dspExcl = sellEx.toFixed(2);
          updated.dspIncl = sellIn.toFixed(2);
          updated.dspIncTax = sellIn.toFixed(2);
        }
        if (field === 'margin') {
          const dpp = parseFloat(updated.dpp) || 0;
          if (dpp > 0) {
            const sellEx = dpp * (1 + (parseFloat(val) || 0) / 100);
            const sellIn = sellEx * (1 + tax);
            updated.dsp = taxType === 'inclusive' ? sellIn.toFixed(2) : sellEx.toFixed(2);
            updated.dspExcl = sellEx.toFixed(2);
            updated.dspIncl = sellIn.toFixed(2);
            updated.dspIncTax = sellIn.toFixed(2);
          }
        }
        if (field === 'dsp') {
          const dpp = parseFloat(updated.dpp) || 0;
          const dspInput = parseFloat(val) || 0;
          if (dspInput > 0) {
            let sellEx = dspInput;
            let sellIn = dspInput;
            if (taxType === 'inclusive') {
              sellEx = dspInput / (1 + tax);
            } else {
              sellIn = dspInput * (1 + tax);
            }

            if (dpp > 0) {
              updated.margin = (((sellEx - dpp) / dpp) * 100).toFixed(2);
            }
            updated.dspExcl = sellEx.toFixed(2);
            updated.dspIncl = sellIn.toFixed(2);
            updated.dspIncTax = sellIn.toFixed(2);
          }
        }
        return updated;
      })
    }));
  };

  const handleComboProductSearch = async (index, query) => {
    // Update the name field for the specific combo item immediately
    setComboItems(prev => prev.map((item, i) => i === index ? { ...item, name: query } : item));

    if (!query || query.length < 2) {
      setComboSearchResults([]);
      setShowComboDropdown(null);
      return;
    }

    setIsSearchingCombo(true);
    setShowComboDropdown(index);
    try {
      const response = await apiService.getProducts({ search: query, per_page: 10 });
      const products = response.data || response || [];
      setComboSearchResults(Array.isArray(products) ? products : []);
    } catch (err) {
      console.error('Combo search failed:', err);
    } finally {
      setIsSearchingCombo(false);
    }
  };

  const handleComboProductSelect = (index, product) => {
    // Extract price - prioritizing selling price for combo items
    let price = product.sell_price_inc_tax || product.default_sell_price || product.selling_price || 0;
    // Extract cost - for internal combo cost tracking
    let cost = product.default_purchase_price || product.purchase_price || 0;

    // Deep check in variations if needed
    if (!price && product.product_variations && product.product_variations.length > 0) {
      const vGroup = product.product_variations[0];
      const variation = vGroup.variations && vGroup.variations[0];
      if (variation) {
        price = variation.sell_price_inc_tax || variation.default_sell_price || 0;
        cost = variation.default_purchase_price || variation.purchase_price || cost;
      }
    }

    setComboItems(prev => prev.map((item, i) => i === index ? {
      ...item,
      id: product.id,
      name: product.name,
      price: price,
      cost: cost
    } : item));
    setShowComboDropdown(null);
    setComboSearchResults([]);
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    // If tax type changed, convert the visible selling price
    if (name === 'sellingPriceTaxType') {
      setFormData(prev => {
        const taxRate = getTaxRate();
        const currentPrice = parseFloat(prev.sellingPrice) || 0;
        let newPrice = currentPrice;

        if (value === 'Inclusive' && prev.sellingPriceTaxType === 'Exclusive') {
          // Switching to Inclusive: price becomes price * (1 + tax)
          newPrice = currentPrice * (1 + taxRate);
        } else if (value === 'Exclusive' && prev.sellingPriceTaxType === 'Inclusive') {
          // Switching to Exclusive: price becomes price / (1 + tax)
          newPrice = currentPrice / (1 + taxRate);
        }

        return {
          ...prev,
          [name]: value,
          sellingPrice: currentPrice > 0 ? newPrice.toFixed(2) : ''
        };
      });
      return;
    }

    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value
    }));
  };

  // Get tax rate based on applicable tax selection
  const getTaxRate = () => {
    const taxMap = {
      'None': 0,
      'NoTax': 0,
      'food': 0.05, // 5%
      'Sales Tax': 0.08, // 8%
      'beer Tax': 0.10, // 10%
      'CIGARETTES': 0.12, // 12%
      'Wine and Liquor 10.5%': 0.105 // 10.5%
    };
    return taxMap[formData.applicableTax] || 0;
  };

  // Handle pricing calculations (unit price, margin, selling price, case price)
  const handlePricingChange = (e) => {
    const { name, value } = e.target;
    const numValue = parseFloat(value) || 0;
    const taxRate = getTaxRate();

    setFormData(prev => {
      let newData = { ...prev, [name]: value };
      const taxType = prev.sellingPriceTaxType;

      // ── Unit purchase price (Exc. Tax) changed ────────────────────────────
      if (name === 'purchasePriceEx') {
        newData.purchasePriceIn = numValue > 0 ? (numValue * (1 + taxRate)).toFixed(2) : '';
        const margin = parseFloat(prev.margin) || 30;
        const sellEx = numValue * (1 + margin / 100);
        const sellIn = sellEx * (1 + taxRate);
        newData.sellingPrice = numValue > 0 ? (taxType === 'Inclusive' ? sellIn.toFixed(2) : sellEx.toFixed(2)) : '';

        // Update Case Price
        const qty = parseFloat(prev.caseQty) || 0;
        if (numValue > 0 && qty > 0) newData.casePrice = (numValue * qty).toFixed(2);
      }

      // ── Unit purchase price (Inc. Tax) changed ────────────────────────────
      if (name === 'purchasePriceIn') {
        const purchaseEx = numValue / (1 + taxRate);
        newData.purchasePriceEx = numValue > 0 ? purchaseEx.toFixed(2) : '';
        const margin = parseFloat(prev.margin) || 30;
        const sellEx = purchaseEx * (1 + margin / 100);
        const sellIn = sellEx * (1 + taxRate);
        newData.sellingPrice = numValue > 0 ? (taxType === 'Inclusive' ? sellIn.toFixed(2) : sellEx.toFixed(2)) : '';

        // Update Case Price
        const qty = parseFloat(prev.caseQty) || 0;
        if (purchaseEx > 0 && qty > 0) newData.casePrice = (purchaseEx * qty).toFixed(2);
      }

      // ── Margin changed ────────────────────────────────────────────────────
      if (name === 'margin') {
        const purchaseEx = parseFloat(prev.purchasePriceEx) || 0;
        if (purchaseEx > 0) {
          const sellEx = purchaseEx * (1 + numValue / 100);
          const sellIn = sellEx * (1 + taxRate);
          newData.sellingPrice = taxType === 'Inclusive' ? sellIn.toFixed(2) : sellEx.toFixed(2);
        }
      }

      // ── Selling price (Visible UI field) changed ──────────────────────────
      if (name === 'sellingPrice') {
        const purchaseEx = parseFloat(prev.purchasePriceEx) || 0;
        if (purchaseEx > 0 && numValue > 0) {
          let sellEx = numValue;
          if (taxType === 'Inclusive') {
            sellEx = numValue / (1 + taxRate);
          }
          const margin = ((sellEx - purchaseEx) / purchaseEx) * 100;
          newData.margin = margin.toFixed(2);
        }
      }

      // ── Case Qty changed ──────────────────────────────────────────────────
      if (name === 'caseQty') {
        const unitPrice = parseFloat(prev.purchasePriceEx) || 0;
        if (numValue > 0 && unitPrice > 0) {
          newData.casePrice = (unitPrice * numValue).toFixed(2);
        }
      }

      // ── Case Price changed ────────────────────────────────────────────────
      if (name === 'casePrice') {
        const qty = parseFloat(prev.caseQty) || 0;
        if (numValue > 0 && qty > 0) {
          const derivedUnit = numValue / qty;
          newData.purchasePriceEx = derivedUnit.toFixed(2);
          newData.purchasePriceIn = (derivedUnit * (1 + taxRate)).toFixed(2);
          const margin = parseFloat(prev.margin) || 30;
          const sellEx = derivedUnit * (1 + margin / 100);
          const sellIn = sellEx * (1 + taxRate);
          newData.sellingPrice = taxType === 'Inclusive' ? sellIn.toFixed(2) : sellEx.toFixed(2);
        }
      }

      return newData;
    });
  };

  // Handle tax change with recalculation
  const handleTaxChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => {
      let newData = { ...prev, [name]: value };

      if (name === 'applicableTax') {
        const taxMap = {
          'None': 0, 'NoTax': 0, 'food': 0.05, 'Sales Tax': 0.08,
          'beer Tax': 0.10, 'CIGARETTES': 0.12, 'Wine and Liquor 10.5%': 0.105
        };
        const newTaxRate = taxMap[value] || 0;
        const purchaseEx = parseFloat(prev.purchasePriceEx) || 0;
        const margin = parseFloat(prev.margin) || 30;

        if (purchaseEx > 0) {
          newData.purchasePriceIn = (purchaseEx * (1 + newTaxRate)).toFixed(2);
          const sellEx = purchaseEx * (1 + margin / 100);
          const sellIn = sellEx * (1 + newTaxRate);
          newData.sellingPrice = prev.sellingPriceTaxType === 'Inclusive' ? sellIn.toFixed(2) : sellEx.toFixed(2);
        }
      }

      return newData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Use the stored submittingAction set by button click
    const action = submittingAction || 'save';
    setIsSubmitting(true);

    try {
      if (!apiService.isTokenValid()) {
        throw new Error('Please login to add products');
      }

      // Map barcode type label → API code
      const barcodeMap = {
        'Code 128 (C128)': 'C128', 'Code 39 (C39)': 'C39',
        'EAN-13': 'EAN-13', 'EAN-8': 'EAN-8', 'UPC-A': 'UPC-A', 'UPC-E': 'UPC-E'
      };

      // Map tax type label → API value
      const taxTypeMap = { 'inclusive': 'inclusive', 'Exc. tax': 'exclusive', 'exclusive': 'exclusive' };

      // Derive cost/price numbers correctly for backend
      const taxRate = getTaxRate();
      const costEx = parseFloat(formData.purchasePriceEx) || 0;
      const costIn = parseFloat(formData.purchasePriceIn) || costEx;
      const priceInput = parseFloat(formData.sellingPrice) || 0;

      let sellIn = 0;
      let sellEx = 0;

      if (formData.sellingPriceTaxType === 'Inclusive') {
        sellIn = priceInput;
        sellEx = sellIn / (1 + taxRate);
      } else {
        sellEx = priceInput;
        sellIn = sellEx * (1 + taxRate);
      }

      // Use higher precision for backend to avoid cumulative rounding issues
      sellEx = parseFloat(sellEx.toFixed(4));
      sellIn = parseFloat(sellIn.toFixed(4));
      const marginPct = parseFloat(formData.margin) || 0;

      // Build the product payload matching the API spec
      const productData = {
        name: formData.productName,
        type: (formData.productType || 'Single').toLowerCase(),
        sku: formData.sku,
        barcode_type: barcodeMap[formData.barcodeType] || 'C128',
        // IDs — the form currently stores text names; backend may accept name or numeric id.
        // When the fetched metadata (units/brands/categories) provides numeric IDs, pass them here.
        unit_id: formData.unit_id || formData.unit || undefined,
        brand_id: formData.brand_id || formData.brand || undefined,
        category_id: formData.category_id || formData.category || undefined,
        sub_category_id: formData.sub_category_id || formData.subcategory || undefined,
        tax: formData.tax_id || undefined,
        tax_type: (formData.sellingPriceTaxType || '').toLowerCase() === 'inclusive' ? 'inclusive' : 'exclusive',
        enable_stock: formData.manageStock ? 1 : 0,
        not_for_selling: formData.notForSelling ? 1 : 0,
        alert_quantity: formData.alertQuantity || undefined,
        product_description: formData.description || undefined,
        weight: formData.weight || undefined,
        preparation_time_in_minutes: formData.preparationTime || undefined,

        // Pricing — single product fields
        single_dpp: costEx || undefined,
        single_dpp_inc_tax: costIn || undefined,
        profit_percent: marginPct || undefined,
        single_dsp: sellEx || undefined,
        single_dsp_inc_tax: sellIn || undefined,

        // Locations — always an array (default location id 1 if not set)
        product_locations: formData.product_locations || [1],

        // Rack details keyed by location id
        product_racks: (formData.rack || formData.row || formData.position)
          ? { 1: { rack: formData.rack || '', row: formData.row || '', position: formData.position || '' } }
          : undefined,

        // Files
        image: formData.image || undefined,
        brochure: formData.brochure || undefined,

        // Opening Stock
        opening_stock: showOpeningStock ? openingStockRows.map(r => ({
          quantity: r.qty,
          unit_cost: r.cost,
          total_amount: (parseFloat(r.qty || 0) * parseFloat(r.cost || 0)).toFixed(2),
          location_id: (formData.product_locations && formData.product_locations[0]) || 1,
          date: r.date,
          note: r.note
        })) : undefined,
      };

      // Variable product — map variationGroups → API product_variation shape
      if (productData.type === 'variable') {
        productData.product_variation = variationGroups.map(group => ({
          name: group.name,
          variations: group.values.map(v => {
            const dpp = parseFloat(v.dpp) || 0;
            const taxVal = getTaxRate();
            const dpp_inc_tax = parseFloat((dpp * (1 + taxVal)).toFixed(4));

            let sellIn = 0;
            let sellEx = 0;
            const dspInput = parseFloat(v.dsp) || 0;

            if (formData.sellingPriceTaxType === 'Inclusive') {
              sellIn = dspInput;
              sellEx = sellIn / (1 + taxVal);
            } else {
              sellEx = dspInput;
              sellIn = sellEx * (1 + taxVal);
            }

            return {
              name: v.name,
              default_purchase_price: dpp,
              dpp_inc_tax: dpp_inc_tax,
              profit_percent: parseFloat(v.margin) || 0,
              default_sell_price: parseFloat(sellEx.toFixed(4)),
              sell_price_inc_tax: parseFloat(sellIn.toFixed(4))
            };
          })
        }));
        // Remove single-product price fields for variable products
        delete productData.single_dpp;
        delete productData.single_dpp_inc_tax;
        delete productData.single_dsp;
        delete productData.single_dsp_inc_tax;
      }

      // Combo product — attach combo sub-products
      if (productData.type === 'combo') {
        productData.combo_products = comboItems.map(c => ({
          product_id: c.id || undefined,
          quantity: parseFloat(c.qty) || 1,
          unit_price: parseFloat(c.price) || 0,
        }));
      }

      // Strip undefined keys before sending
      Object.keys(productData).forEach(k => {
        if (productData[k] === undefined || productData[k] === null || productData[k] === '') {
          delete productData[k];
        }
      });

      console.log('Submitting product data:', productData);

      const response = isEditMode
        ? await apiService.updateProduct(editProduct.id, productData)
        : await apiService.createProduct(productData);

      console.log(isEditMode ? 'Product updated:' : 'Product created:', response);

      // Handle API-level error in response body
      if (response && response.success === false) {
        throw new Error(response.message || 'Failed to save product');
      }

      setShowSuccess(true);
      setTimeout(() => {
        if (action === 'save_and_add') {
          topRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
        setShowSuccess(false);
        setFormData({
          productName: '', sku: '', barcodeType: 'Code 128 (C128)', unit: '', brand: '',
          category: '', subcategory: '', businessLocation: "Lefty'S Liquor (BL0001)",
          alertQuantity: '', manageStock: true, description: '', image: null, brochure: null,
          enableDescription: false, notForSelling: false, weight: '', preparationTime: '',
          applicableTax: 'None', sellingPriceTaxType: 'exclusive', productType: 'Single',
          defaultPurchasePrice: '', margin: '', defaultSellingPrice: '',
          purchasePriceEx: '', purchasePriceIn: '', sellingPrice: '',
          caseQty: '', casePrice: '', disableWoocommerceSync: false,
          relatedSubUnits: '', rack: '', row: '', position: '',
        });
        setImagePreview(null);
        setBrochureName('');
        setBrochurePreview(null);

        if (action === 'save_and_add') {
          setTimeout(() => {
            topRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        } else {
          if (onClose) {
            onClose();
          } else {
            navigate('/products');
          }
        }
      }, 3000);
    } catch (error) {
      console.error('Error submitting product:', error);
      alert(`Failed to save product: ${error.message}`);
    } finally {
      setIsSubmitting(false);
      setSubmittingAction(null);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, image: file }));
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleBrochureChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, brochure: file }));
      setBrochureName(file.name);
      setBrochurePreview(null);
      setBrochureText('');

      const reader = new FileReader();
      reader.onloadend = () => {
        setBrochurePreview(reader.result);
      };
      reader.readAsDataURL(file);

      // If it's a potential text/EDI file, also read as text
      const isTxt = file.type.startsWith('text/') ||
        file.type === 'application/json' ||
        file.type === 'application/xml' ||
        /\.(edi|x12|txt|csv|xml|json)$/i.test(file.name);

      if (isTxt) {
        const textReader = new FileReader();
        textReader.onloadend = () => {
          setBrochureText(textReader.result);
        };
        textReader.readAsText(file);
      }
    }
  };

  return (
    <div className={`add-product-container add-sell-override ${isModal ? 'is-modal-view' : ''}`} style={isModal ? { width: '100%', maxWidth: '100%', boxSizing: 'border-box', margin: 0, border: 'none', boxShadow: 'none' } : {}}>
      {showSuccess && (
        <div className="success-message">
          {isEditMode ? 'Product updated successfully!' : 'Product added successfully!'}
        </div>
      )}

      {!isModal && (
        <div className="page-header">
          <button
            onClick={onClose}
            style={{
              background: 'white',
              border: '1px solid #e2e8f0',
              borderRadius: '8px',
              padding: '0.5rem 0.75rem',
              cursor: 'pointer',
              fontSize: '1.2rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '40px',
              height: '40px'
            }}
            title="Back to Products"
          >
            ←
          </button>
          <h2 ref={topRef} style={{ fontSize: '1.25rem' }}>{isEditMode ? 'Edit Product' : 'Add New Product'}</h2>
        </div>
      )}
      <form onSubmit={handleSubmit} className="product-form">
        {/* Basic Information Section */}
        <div className="form-section">
          <h3>Basic Information</h3>
          {/* First Row: Name, SKU, Barcode */}
          <div className="form-row">
            <div className="form-group required">
              <label>Product Name:*</label>
              <input
                type="text"
                name="productName"
                value={formData.productName}
                onChange={handleChange}
                required
                placeholder="Product Name"
              />
            </div>

            <div className="form-group">
              <label>
                SKU:
                <span className="info-icon" title="Unique product ID">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                  </svg>
                </span>
              </label>
              <input
                type="text"
                name="sku"
                value={formData.sku}
                onChange={handleChange}
                placeholder="SKU"
              />
            </div>

            <div className="form-group required">
              <label>Barcode Type:*</label>
              <select
                name="barcodeType"
                value={formData.barcodeType}
                onChange={handleChange}
                required
              >
                {barcodeTypes.map(type => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Second Row: Unit, Related Sub Units, Brand */}
          <div className="form-row">
            <div className="form-group required">
              <label>Unit:*</label>
              <div className="input-with-button">
                <select
                  name="unit_id"
                  value={formData.unit_id || ''}
                  onChange={handleChange}
                  required
                >
                  <option value="">Please Select</option>
                  {unitsList.map(u => (
                    <option key={u.id} value={u.id}>{u.actual_name || u.name}</option>
                  ))}
                </select>
                <button type="button" className="add-btn" onClick={() => setShowUnitModal(true)}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                </button>
              </div>
            </div>

            <div className="form-group">
              <label>
                Related Sub Units:
                <span className="info-icon" title="Sub units">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                  </svg>
                </span>
              </label>
              <input
                type="text"
                name="relatedSubUnits"
                value={formData.relatedSubUnits}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Brand:</label>
              <div className="input-with-button">
                <select
                  name="brand_id"
                  value={formData.brand_id || ''}
                  onChange={handleChange}
                >
                  <option value="">Please Select</option>
                  {brandsList.map(b => (
                    <option key={b.id} value={b.id}>{b.name}</option>
                  ))}
                </select>
                <button
                  type="button"
                  className="add-btn"
                  onClick={() => setShowBrandModal(true)}
                  title="Add new brand"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* Third Row: Category, Sub Category, Business Locations */}
          <div className="form-row">
            <div className="form-group">
              <label>Category:</label>
              <select
                name="category_id"
                value={formData.category_id || ''}
                onChange={handleChange}
              >
                <option value="">Please Select</option>
                {categoriesList.map(cat => (
                  <option key={cat.id} value={cat.id}>{cat.name}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Sub category:</label>
              <input
                type="text"
                name="subcategory"
                value={formData.subcategory}
                onChange={handleChange}
                placeholder="Sub category"
              />
            </div>

            <div className="form-group">
              <label>
                Business Locations:
                <span className="info-icon" title="Business locations">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                  </svg>
                </span>
              </label>
              <div className="chips-input-container">
                <span className="location-tag">
                  <span className="remove-tag">×</span>
                  Lefty'S Liquor (BL0001)
                </span>
                <input
                  type="text"
                  placeholder=""
                  className="chips-input"
                />
              </div>
              <div className="location-dropdown" style={{ display: 'none' }}>
                <div className="dropdown-item">Lefty'S Liquor (BL0001)</div>
              </div>
            </div>
          </div>


          {/* Fourth Row: Manage Stock, Alert Quantity */}
          <div className="form-row">
            <div className="form-group checkbox-group-styled">
              <label className="checkbox-label bold-label">
                <input
                  type="checkbox"
                  name="manageStock"
                  checked={formData.manageStock}
                  onChange={handleChange}
                />
                <span className="checkbox-custom"></span>
                Manage Stock?
                <span className="info-icon" title="Manage stocks">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                  </svg>
                </span>
              </label>
              <small className="help-text">Enable stock management at product level</small>
            </div>

            {formData.manageStock && (
              <div className="form-group">
                <label>
                  Alert quantity:
                  <span className="info-icon" title="Alert quantity">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12.01" y2="8"></line>
                    </svg>
                  </span>
                </label>
                <input
                  type="number"
                  name="alertQuantity"
                  value={formData.alertQuantity}
                  onChange={handleChange}
                  placeholder="Alert quantity"
                />
              </div>
            )}
          </div>

          {/* Fifth Row: Description and Media */}
          <div className="form-row description-row">
            <div className="form-group description-group">
              <label>Product Description:</label>
              <ReactQuill
                theme="snow"
                value={formData.description || ''}
                onChange={(value) => setFormData(prev => ({ ...prev, description: value }))}
                placeholder="Product Description"
                style={{ height: '200px', marginBottom: '3rem' }}
              />
            </div>

            <div className="media-column">
              <div className="form-group brochure-group">
                <label>Product brochure:</label>
                <div className="file-input-wrapper">
                  <input
                    type="file"
                    name="brochure"
                    id="brochure-upload"
                    onChange={handleBrochureChange}
                    accept=".pdf,.csv,.zip,.doc,.docx,.jpeg,.jpg,.png"
                  />
                  <label htmlFor="brochure-upload" className="choose-file-btn">
                    Choose File
                  </label>
                  <span style={{ marginLeft: '10px', fontSize: '0.85rem', color: '#64748b' }}>
                    {brochureName || 'No file chosen'}
                  </span>
                </div>
                <small>Max File size: 5MB</small>
                <small>Allowed File: .pdf, .csv, .zip, .doc, .docx, .jpeg, .jpg, .png</small>

                {formData.brochure && (
                  <div style={{ marginTop: '10px' }}>
                    <button
                      type="button"
                      onClick={() => setShowBrochureModal(true)}
                      style={{
                        padding: '6px 16px',
                        fontSize: '0.875rem',
                        backgroundColor: '#3b82f6',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        fontWeight: '500'
                      }}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                      View Uploaded File
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div >

        {/* Additional Details Section */}
        < div className="form-section" >
          <div className="checkbox-row">
            <div className="form-group" style={{ margin: 0 }}>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="enableDescription"
                  checked={formData.enableDescription}
                  onChange={handleChange}
                />
                <span className="checkbox-custom"></span>
                Enable Product description, IMEI or Serial Number
                <span className="info-icon" title="Enable description">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                  </svg>
                </span>
              </label>
            </div>

            <div className="form-group" style={{ margin: 0 }}>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="notForSelling"
                  checked={formData.notForSelling}
                  onChange={handleChange}
                />
                <span className="checkbox-custom"></span>
                Not for selling
                <span className="info-icon" title="Not for selling">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                  </svg>
                </span>
              </label>
            </div>

            <div className="form-group" style={{ margin: 0 }}>
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="disableWoocommerceSync"
                  checked={formData.disableWoocommerceSync}
                  onChange={handleChange}
                />
                <span className="checkbox-custom"></span>
                Disable Woocommerce Sync
                <span className="info-icon">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                  </svg>
                </span>
              </label>
            </div>
          </div>



          {/* Rack Details Row */}
          <div className="form-row">
            <div className="form-group full-width rack-details">
              <label>
                <div>
                  Rack/Row/Position Details:
                  <span className="info-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12.01" y2="8"></line>
                    </svg>
                  </span>
                </div>
                <span className="location-name">Lefty'S Liquor (BL0001):</span>
              </label>
              <div className="rack-inputs">
                <input type="text" name="rack" placeholder="Rack" value={formData.rack} onChange={handleChange} />
                <input type="text" name="row" placeholder="Row" value={formData.row} onChange={handleChange} />
                <input type="text" name="position" placeholder="Position" value={formData.position} onChange={handleChange} />
              </div>
            </div>
          </div>

          {/* Weight and Timer Row */}
          <div className="form-row">
            <div className="form-group full-width">
              <div className="rack-inputs">
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                  <label style={{ fontWeight: 600, fontSize: '0.875rem', marginBottom: '0.25rem' }}>Weight:</label>
                  <input
                    type="text"
                    name="weight"
                    value={formData.weight}
                    onChange={handleChange}
                    placeholder="Weight"
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                  <label style={{ fontWeight: 600, fontSize: '0.875rem', marginBottom: '0.25rem' }}>Service staff timer/Preparation time (In min):</label>
                  <input
                    type="text"
                    name="preparationTime"
                    value={formData.preparationTime}
                    onChange={handleChange}
                    placeholder="Service staff timer/Preparation time"
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                  <label style={{ fontWeight: 600, fontSize: '0.875rem', marginBottom: '0.25rem' }}>Product image:</label>
                  <div className="image-input-container">
                    <div className="file-input-group">
                      <input
                        type="text"
                        className="file-name-input"
                        readOnly
                        placeholder=""
                        value={formData.image ? formData.image.name : ''}
                        disabled
                      />
                      <input
                        type="file"
                        name="image"
                        id="product-image-upload"
                        onChange={handleImageChange}
                        accept="image/*"
                        style={{ display: 'none' }}
                      />
                      <label htmlFor="product-image-upload" className="browse-btn">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                        </svg>
                        Browse..
                      </label>
                    </div>
                    <small>Max File size: 5MB</small>
                    <small>Aspect ratio should be 1:1</small>

                    {formData.image && (
                      <div style={{ marginTop: '10px' }}>
                        <button
                          type="button"
                          onClick={() => setShowImageModal(true)}
                          style={{
                            padding: '6px 16px',
                            fontSize: '0.875rem',
                            backgroundColor: '#3b82f6',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            fontWeight: '500'
                          }}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                          View Uploaded Image
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >

        {/* Additional Settings Section Removed (Merged above) */}

        {/* Pricing Section */}
        <div className="form-section">
          <h3>Pricing</h3>
          <div className="form-row-5">
            <div className="form-group required">
              <label>Default Purchase Price:*</label>
              <select
                name="applicableTax"
                value={formData.applicableTax}
                onChange={handleTaxChange}
              >
                {taxOptions.map(tax => (
                  <option key={tax} value={tax}>{tax}</option>
                ))}
              </select>
            </div>

            <div className="form-group required">
              <label>Selling Price Tax Type:*</label>
              <select
                name="sellingPriceTaxType"
                value={formData.sellingPriceTaxType}
                onChange={handleChange}
                required
              >
                <option value="Exclusive">Exclusive</option>
                <option value="Inclusive">Inclusive</option>
              </select>
            </div>

            <div className="form-group required">
              <label>
                Product Type:*
                <span className="info-icon">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                  </svg>
                </span>
              </label>
              <select
                name="productType"
                value={formData.productType}
                onChange={handleChange}
                required
              >
                <option value="Single">Single</option>
                <option value="Variable">Variable</option>
                <option value="Combo">Combo</option>
              </select>
            </div>

            <div className="form-group">
              <label>
                Case Qty:
                <span style={{ fontSize: '0.75rem', color: '#64748b', fontWeight: 400, marginLeft: '0.25rem' }}>(units/case)</span>
              </label>
              <input
                type="number"
                name="caseQty"
                value={formData.caseQty}
                onChange={handlePricingChange}
                placeholder="e.g. 10"
                min="1"
              />
            </div>

            <div className="form-group">
              <label>
                Case Price:
                <span style={{ fontSize: '0.75rem', color: '#64748b', fontWeight: 400, marginLeft: '0.25rem' }}>(total cost)</span>
              </label>
              <input
                type="number"
                name="casePrice"
                value={formData.casePrice}
                onChange={handlePricingChange}
                placeholder="e.g. 1200"
                step="0.01"
              />
              {formData.caseQty && formData.casePrice && (
                <small style={{ color: '#64748b', marginTop: '0.3rem', display: 'block' }}>
                  Unit price: ${(parseFloat(formData.casePrice) / parseFloat(formData.caseQty)).toFixed(2)} each
                </small>
              )}
            </div>
          </div>

          <div className="pricing-table-container">
            <table className="pricing-table">
              <thead>
                <tr>
                  <th className="green-header" colSpan="2">Default Purchase Price</th>
                  <th className="green-header">
                    x Margin(%)
                    <span className="info-icon inverted">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="16" x2="12" y2="12"></line>
                        <line x1="12" y1="8" x2="12.01" y2="8"></line>
                      </svg>
                    </span>
                  </th>
                  <th className="green-header">Default Selling Price</th>
                </tr>
                <tr className="sub-header">
                  <th>Exc. tax:*</th>
                  <th>Inc. tax:*</th>
                  <th></th>
                  <th>{formData.sellingPriceTaxType === 'Inclusive' ? 'Inc. Tax' : 'Exc. Tax'}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="number"
                      name="purchasePriceEx"
                      value={formData.purchasePriceEx}
                      onChange={handlePricingChange}
                      placeholder="Exc. tax"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="purchasePriceIn"
                      value={formData.purchasePriceIn}
                      onChange={handlePricingChange}
                      placeholder="Inc. tax"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="margin"
                      value={formData.margin || '30.00'}
                      onChange={handlePricingChange}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="sellingPrice"
                      value={formData.sellingPrice}
                      onChange={handlePricingChange}
                      placeholder={formData.sellingPriceTaxType === 'Inclusive' ? 'Inc. Tax' : 'Exc. Tax'}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* ── VARIABLE: Variation Builder ─────────────────────────────────────── */}
        {formData.productType === 'Variable' && (
          <div className="form-section">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ margin: 0 }}>Variations</h3>
              <button type="button" className="btn btn-blue" style={{ padding: '0.4rem 1rem', fontSize: '0.85rem' }} onClick={addVariationGroup}>
                + Add Variation Group
              </button>
            </div>

            {variationGroups.map((group, gi) => (
              <div key={gi} style={{ border: '1px solid #e2e8f0', borderRadius: '10px', padding: '1rem', marginBottom: '1rem', background: '#f8fafc' }}>
                {/* Group header */}
                <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', marginBottom: '0.75rem' }}>
                  <input
                    type="text"
                    placeholder="Variation name (e.g. Size, Color)"
                    value={group.name}
                    onChange={e => updateVariationGroup(gi, 'name', e.target.value)}
                    style={{ flex: 1, padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.875rem', fontWeight: '600' }}
                  />
                  {variationGroups.length > 1 && (
                    <button type="button" onClick={() => removeVariationGroup(gi)}
                      style={{ padding: '0.4rem 0.75rem', background: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5', borderRadius: '6px', cursor: 'pointer', fontSize: '0.8rem' }}>
                      Remove Group
                    </button>
                  )}
                </div>

                {/* Variation values table */}
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem' }}>
                    <thead>
                      <tr style={{ background: '#4a7c59', color: 'white' }}>
                        <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', minWidth: 120 }}>Value Name</th>
                        <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', minWidth: 100 }}>Purchase (Exc.)</th>
                        <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', minWidth: 100 }}>Purchase (Inc.)</th>
                        <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', minWidth: 80 }}>Margin %</th>
                        <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', minWidth: 100 }}>
                          {formData.sellingPriceTaxType === 'Inclusive' ? 'Sell (Inc.)*' : 'Sell (Exc.)*'}
                        </th>
                        <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', minWidth: 100 }}>
                          {formData.sellingPriceTaxType === 'Inclusive' ? 'Sell (Exc.)' : 'Sell (Inc.)'}
                        </th>
                        <th style={{ padding: '0.5rem 0.75rem', width: 40 }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {group.values.map((v, vi) => (
                        <tr key={vi} style={{ borderBottom: '1px solid #e2e8f0', background: vi % 2 === 0 ? '#fff' : '#f8fafc' }}>
                          <td style={{ padding: '0.4rem 0.5rem' }}>
                            <input type="text" placeholder="e.g. Small" value={v.name}
                              onChange={e => updateVariationValue(gi, vi, 'name', e.target.value)}
                              style={{ width: '100%', padding: '0.35rem 0.5rem', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '0.8rem' }} />
                          </td>
                          <td style={{ padding: '0.4rem 0.5rem' }}>
                            <input type="number" placeholder="0.00" value={v.dpp}
                              onChange={e => updateVariationValue(gi, vi, 'dpp', e.target.value)}
                              style={{ width: '100%', padding: '0.35rem 0.5rem', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '0.8rem' }} />
                          </td>
                          <td style={{ padding: '0.4rem 0.5rem' }}>
                            <input type="number" placeholder="0.00" value={v.dppIncTax} readOnly
                              style={{ width: '100%', padding: '0.35rem 0.5rem', border: '1px solid #e2e8f0', borderRadius: '4px', fontSize: '0.8rem', background: '#f1f5f9', color: '#64748b' }} />
                          </td>
                          <td style={{ padding: '0.4rem 0.5rem' }}>
                            <input type="number" placeholder="30" value={v.margin}
                              onChange={e => updateVariationValue(gi, vi, 'margin', e.target.value)}
                              style={{ width: '100%', padding: '0.35rem 0.5rem', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '0.8rem' }} />
                          </td>
                          <td style={{ padding: '0.4rem 0.5rem' }}>
                            <input type="number" placeholder="0.00" value={v.dsp}
                              onChange={e => updateVariationValue(gi, vi, 'dsp', e.target.value)}
                              style={{ width: '100%', padding: '0.35rem 0.5rem', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '0.8rem' }} />
                          </td>
                          <td style={{ padding: '0.4rem 0.5rem' }}>
                            <input type="number" placeholder="0.00"
                              value={formData.sellingPriceTaxType === 'Inclusive' ? v.dspExcl : v.dspIncl}
                              readOnly
                              style={{ width: '100%', padding: '0.35rem 0.5rem', border: '1px solid #e2e8f0', borderRadius: '4px', fontSize: '0.8rem', background: '#f1f5f9', color: '#64748b' }} />
                          </td>
                          <td style={{ padding: '0.4rem 0.5rem' }}>
                            {group.values.length > 1 && (
                              <button type="button" onClick={() => removeVariationValue(gi, vi)}
                                style={{ background: '#ef4444', color: 'white', border: 'none', borderRadius: '4px', width: 28, height: 28, cursor: 'pointer', fontSize: '1rem', lineHeight: 1 }}>×</button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <button type="button" onClick={() => addVariationValue(gi)}
                  style={{ marginTop: '0.6rem', padding: '0.35rem 0.9rem', background: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe', borderRadius: '6px', cursor: 'pointer', fontSize: '0.8rem', fontWeight: '600' }}>
                  + Add Row
                </button>
              </div>
            ))}
          </div>
        )}

        {/* ── COMBO: Add Sub-products ──────────────────────────────────────────── */}
        {formData.productType === 'Combo' && (
          <div className="form-section">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ margin: 0 }}>Combo Items</h3>
              <button type="button" className="btn btn-blue" style={{ padding: '0.4rem 1rem', fontSize: '0.85rem' }}
                onClick={() => setComboItems(prev => [...prev, { name: '', qty: 1, price: '' }])}>
                + Add Item
              </button>
            </div>

            {comboItems.length === 0 && (
              <div style={{ textAlign: 'center', padding: '2rem', color: '#94a3b8', border: '2px dashed #e2e8f0', borderRadius: '10px' }}>
                No items added yet. Click "+ Add Item" to build your combo product.
              </div>
            )}

            {comboItems.length > 0 && (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
                <thead>
                  <tr style={{ background: '#4a7c59', color: 'white' }}>
                    <th style={{ padding: '0.6rem 0.75rem', textAlign: 'left' }}>Product Name</th>
                    <th style={{ padding: '0.6rem 0.75rem', textAlign: 'left', width: 100 }}>Qty</th>
                    <th style={{ padding: '0.6rem 0.75rem', textAlign: 'left', width: 130 }}>Unit Price</th>
                    <th style={{ padding: '0.6rem 0.75rem', textAlign: 'left', width: 130 }}>Total</th>
                    <th style={{ padding: '0.6rem 0.75rem', width: 40 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {comboItems.map((item, idx) => (
                    <tr key={idx} style={{ borderBottom: '1px solid #e2e8f0' }}>
                      <td style={{ padding: '0.4rem 0.5rem', position: 'relative' }}>
                        <input
                          type="text"
                          placeholder="Product name or SKU"
                          value={item.name}
                          onChange={e => handleComboProductSearch(idx, e.target.value)}
                          onFocus={() => item.name && item.name.length >= 2 && setShowComboDropdown(idx)}
                          style={{ width: '100%', padding: '0.4rem 0.6rem', border: '1px solid #d1d5db', borderRadius: '5px', fontSize: '0.85rem' }}
                        />
                        {showComboDropdown === idx && (comboSearchResults.length > 0 || isSearchingCombo) && (
                          <div className="combo-search-dropdown" style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            right: 0,
                            backgroundColor: 'white',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                            zIndex: 1000,
                            maxHeight: '250px',
                            overflowY: 'auto',
                            marginTop: '2px'
                          }}>
                            {isSearchingCombo && (
                              <div style={{ padding: '10px', color: '#64748b', fontSize: '0.85rem', textAlign: 'center' }}>Searching...</div>
                            )}
                            {!isSearchingCombo && comboSearchResults.map((product) => (
                              <div
                                key={product.id}
                                className="combo-dropdown-item"
                                onClick={() => handleComboProductSelect(idx, product)}
                                style={{
                                  padding: '10px 15px',
                                  cursor: 'pointer',
                                  borderBottom: '1px solid #f1f5f9',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: '2px'
                                }}
                              >
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <span style={{ fontWeight: '600', color: '#1e293b' }}>{product.name}</span>
                                  <span style={{ color: '#10b981', fontWeight: '600', fontSize: '0.8rem' }}>
                                    ${product.sell_price_inc_tax || product.default_sell_price || product.selling_price || '0.00'}
                                  </span>
                                </div>
                                <span style={{ fontSize: '0.75rem', color: '#64748b' }}>SKU: {product.sku}</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </td>
                      <td style={{ padding: '0.4rem 0.5rem' }}>
                        <input type="number" min="1" value={item.qty}
                          onChange={e => setComboItems(prev => prev.map((c, i) => i !== idx ? c : { ...c, qty: e.target.value }))}
                          style={{ width: '100%', padding: '0.4rem 0.6rem', border: '1px solid #d1d5db', borderRadius: '5px', fontSize: '0.85rem' }} />
                      </td>
                      <td style={{ padding: '0.4rem 0.5rem' }}>
                        <input type="number" step="0.01" placeholder="0.00" value={item.price}
                          onChange={e => setComboItems(prev => prev.map((c, i) => i !== idx ? c : { ...c, price: e.target.value }))}
                          style={{ width: '100%', padding: '0.4rem 0.6rem', border: '1px solid #d1d5db', borderRadius: '5px', fontSize: '0.85rem' }} />
                      </td>
                      <td style={{ padding: '0.4rem 0.5rem', color: '#374151', fontWeight: '600' }}>
                        ${((parseFloat(item.qty) || 0) * (parseFloat(item.price) || 0)).toFixed(2)}
                      </td>
                      <td style={{ padding: '0.4rem 0.5rem' }}>
                        <button type="button" onClick={() => setComboItems(prev => prev.filter((_, i) => i !== idx))}
                          style={{ background: '#ef4444', color: 'white', border: 'none', borderRadius: '4px', width: 28, height: 28, cursor: 'pointer', fontSize: '1rem' }}>×</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{ background: '#f1f5f9' }}>
                    <td colSpan={3} style={{ padding: '0.6rem 0.75rem', fontWeight: '700', textAlign: 'right' }}>Combo Total:</td>
                    <td style={{ padding: '0.6rem 0.75rem', fontWeight: '700', color: '#1e40af' }}>
                      ${comboItems.reduce((sum, c) => sum + (parseFloat(c.qty) || 0) * (parseFloat(c.price) || 0), 0).toFixed(2)}
                    </td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            )}
          </div>
        )}

        {/* ── OPENING STOCK: Expandable Section ──────────────────────────────── */}
        {showOpeningStock && (
          <div className="form-section opening-stock-section" style={{ marginTop: '2rem', padding: '1.5rem', background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)' }}>
            <h2 style={{ margin: '0 0 1rem 0', fontSize: '1.4rem', color: '#0f172a' }}>Add Opening Stock</h2>
            <div style={{ marginBottom: '1.5rem', fontSize: '0.95rem', color: '#475569' }}>
              Location: {formData.businessLocation}
            </div>

            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
                <thead>
                  <tr style={{ background: '#2dd4bf', color: 'white' }}>
                    <th style={{ padding: '0.75rem', textAlign: 'left', minWidth: '120px' }}>Product Name</th>
                    <th style={{ padding: '0.75rem', textAlign: 'left', minWidth: '160px' }}>Quantity Remaining</th>
                    <th style={{ padding: '0.75rem', textAlign: 'left', minWidth: '130px' }}>Unit Cost (Before Tax)</th>
                    <th style={{ padding: '0.75rem', textAlign: 'center', minWidth: '130px' }}>Subtotal (Before Tax)</th>
                    <th style={{ padding: '0.75rem', textAlign: 'left', minWidth: '130px' }}>Date</th>
                    <th style={{ padding: '0.75rem', textAlign: 'left', minWidth: '200px' }}>Note</th>
                    <th style={{ padding: '0.75rem', textAlign: 'center', minWidth: '60px' }}></th>
                  </tr>
                </thead>
                <tbody>
                  {openingStockRows.map((row, idx) => {
                    const rowQty = parseFloat(row.qty) || 0;
                    const rowCost = parseFloat(row.cost) || 0;
                    const subtotal = (rowQty * rowCost).toFixed(2);
                    return (
                      <tr key={row.id} style={{ borderBottom: '1px solid #e2e8f0', background: idx % 2 === 0 ? '#fff' : '#f8fafc' }}>
                        <td style={{ padding: '0.75rem' }}>{formData.productName || 'dummy1'}</td>
                        <td style={{ padding: '0.75rem' }}>
                          <div style={{ display: 'flex', gap: '4px' }}>
                            <input
                              type="number"
                              value={row.qty}
                              onChange={(e) => updateOpeningStockRow(row.id, 'qty', e.target.value)}
                              placeholder="0.00"
                              style={{ width: '60px', padding: '0.4rem', border: '1px solid #cbd5e1', borderRadius: '4px' }}
                            />
                            <input
                              type="text"
                              value={formData.productType}
                              readOnly
                              style={{ width: '70px', padding: '0.4rem', border: '1px solid #cbd5e1', borderRadius: '4px', background: '#f1f5f9', color: '#64748b' }}
                            />
                          </div>
                        </td>
                        <td style={{ padding: '0.75rem' }}>
                          <input
                            type="number"
                            step="0.01"
                            value={row.cost}
                            onChange={(e) => updateOpeningStockRow(row.id, 'cost', e.target.value)}
                            placeholder="0.00"
                            style={{ width: '100%', padding: '0.4rem', border: '1px solid #cbd5e1', borderRadius: '4px' }}
                          />
                        </td>
                        <td style={{ padding: '0.75rem', textAlign: 'center', fontWeight: '600' }}>
                          {subtotal}
                        </td>
                        <td style={{ padding: '0.75rem' }}>
                          <input
                            type="date"
                            value={row.date}
                            onChange={(e) => updateOpeningStockRow(row.id, 'date', e.target.value)}
                            style={{ width: '100%', padding: '0.4rem', border: '1px solid #cbd5e1', borderRadius: '4px' }}
                          />
                        </td>
                        <td style={{ padding: '0.75rem' }}>
                          <textarea
                            value={row.note}
                            onChange={(e) => updateOpeningStockRow(row.id, 'note', e.target.value)}
                            rows="2"
                            style={{ width: '100%', padding: '0.4rem', border: '1px solid #cbd5e1', borderRadius: '4px', resize: 'vertical' }}
                          />
                        </td>
                        <td style={{ padding: '0.75rem', textAlign: 'center', verticalAlign: 'top' }}>
                          {idx === 0 ? (
                            <button type="button" onClick={handleAddOpeningStockRow} style={{ background: 'white', color: '#8b5cf6', border: '1px solid #8b5cf6', borderRadius: '4px', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', cursor: 'pointer', margin: '0 auto' }}>+</button>
                          ) : (
                            <button type="button" onClick={() => handleRemoveOpeningStockRow(row.id)} style={{ background: 'white', color: '#ef4444', border: '1px solid #ef4444', borderRadius: '4px', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', cursor: 'pointer', margin: '0 auto' }}>✕</button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr style={{ background: '#f8fafc' }}>
                    <td colSpan={3} style={{ padding: '1rem 0.75rem', textAlign: 'right', fontWeight: '700' }}>Total Amount (Exc. Tax):</td>
                    <td style={{ padding: '1rem 0.75rem', textAlign: 'center', fontWeight: '700' }}>
                      {openingStockRows.reduce((sum, r) => sum + (parseFloat(r.qty) || 0) * (parseFloat(r.cost) || 0), 0).toFixed(2)}
                    </td>
                    <td colSpan={3}></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        )}

        <div className="form-actions custom-actions" style={{ justifyContent: 'center', marginTop: '2rem' }}>
          {!showOpeningStock && (
            <button type="button" className="btn btn-purple" onClick={handleShowOpeningStock}>
              Save & Add Opening Stock
            </button>
          )}
          <button
            type="submit"
            name="submitAction"
            value="save"
            className="btn btn-blue"
            disabled={isSubmitting}
            style={{ padding: '0.6rem 2.5rem', fontSize: '1.1rem' }}
            onClick={() => setSubmittingAction('save')}
          >
            {isSubmitting && submittingAction === 'save' ? 'Saving...' : 'Save'}
          </button>
          {!showOpeningStock && (
            <button
              type="submit"
              name="submitAction"
              value="save_and_add"
              className="btn btn-red"
              disabled={isSubmitting}
              onClick={() => setSubmittingAction('save_and_add')}
            >
              {isSubmitting && submittingAction === 'save_and_add' ? 'Saving...' : 'Save And Add Another'}
            </button>
          )}
        </div>
      </form >


      <AddBrandModal
        isOpen={showBrandModal}
        onClose={() => setShowBrandModal(false)}
        onSave={handleAddBrand}
      />

      <AddUnitModal
        isOpen={showUnitModal}
        onClose={() => setShowUnitModal(false)}
        onSave={handleAddUnit}
      />

      <AddCategoryModal
        isOpen={showCategoryModal}
        onClose={() => setShowCategoryModal(false)}
        onSave={handleAddCategory}
        categories={categoriesList}
      />

      {/* Product Image Modal */}
      {showImageModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '20px'
          }}
          onClick={() => setShowImageModal(false)}
        >
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              width: '95vw',
              height: '95vh',
              overflow: 'auto',
              position: 'relative',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{
              padding: '20px',
              borderBottom: '1px solid #e2e8f0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'sticky',
              top: 0,
              backgroundColor: 'white',
              zIndex: 1
            }}>
              <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '600', color: '#1e293b' }}>
                Product Image Preview
              </h3>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginRight: '10px' }}>
                  <button
                    onClick={() => setImageZoom(prev => Math.max(0.5, prev - 0.25))}
                    style={{
                      background: '#f1f5f9',
                      border: '1px solid #cbd5e1',
                      borderRadius: '6px',
                      padding: '6px 12px',
                      cursor: 'pointer',
                      fontSize: '1rem',
                      fontWeight: '600',
                      color: '#475569'
                    }}
                    title="Zoom Out"
                  >
                    −
                  </button>
                  <span style={{ fontSize: '0.875rem', fontWeight: '500', color: '#64748b', minWidth: '50px', textAlign: 'center' }}>
                    {Math.round(imageZoom * 100)}%
                  </span>
                  <button
                    onClick={() => setImageZoom(prev => Math.min(3, prev + 0.25))}
                    style={{
                      background: '#f1f5f9',
                      border: '1px solid #cbd5e1',
                      borderRadius: '6px',
                      padding: '6px 12px',
                      cursor: 'pointer',
                      fontSize: '1rem',
                      fontWeight: '600',
                      color: '#475569'
                    }}
                    title="Zoom In"
                  >
                    +
                  </button>
                  <button
                    onClick={() => setImageZoom(1)}
                    style={{
                      background: '#f1f5f9',
                      border: '1px solid #cbd5e1',
                      borderRadius: '6px',
                      padding: '6px 12px',
                      cursor: 'pointer',
                      fontSize: '0.75rem',
                      fontWeight: '500',
                      color: '#475569'
                    }}
                    title="Reset Zoom"
                  >
                    Reset
                  </button>
                </div>
                <button
                  onClick={() => { setShowImageModal(false); setImageZoom(1); }}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '1.5rem',
                    cursor: 'pointer',
                    color: '#64748b',
                    padding: '0',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px'
                  }}
                >
                  ×
                </button>
              </div>
            </div>
            <div style={{ padding: '20px', overflow: 'auto' }}>
              {imagePreview && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={imagePreview}
                    alt="Product"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '80vh',
                      objectFit: 'contain',
                      borderRadius: '8px',
                      transform: `scale(${imageZoom})`,
                      transition: 'transform 0.2s ease',
                      cursor: imageZoom > 1 ? 'move' : 'default'
                    }}
                  />
                  <div style={{ marginTop: '20px', fontSize: '0.875rem', color: '#64748b' }}>
                    <strong>File:</strong> {formData.image?.name}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Product Brochure Modal */}
      {showBrochureModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '20px'
          }}
          onClick={() => setShowBrochureModal(false)}
        >
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              width: '95vw',
              height: '95vh',
              overflow: 'auto',
              position: 'relative',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{
              padding: '20px',
              borderBottom: '1px solid #e2e8f0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'sticky',
              top: 0,
              backgroundColor: 'white',
              zIndex: 1
            }}>
              <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '600', color: '#1e293b' }}>
                Product Brochure Preview
              </h3>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {formData.brochure?.type.startsWith('image/') && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginRight: '10px' }}>
                    <button
                      onClick={() => setBrochureZoom(prev => Math.max(0.5, prev - 0.25))}
                      style={{
                        background: '#f1f5f9',
                        border: '1px solid #cbd5e1',
                        borderRadius: '6px',
                        padding: '6px 12px',
                        cursor: 'pointer',
                        fontSize: '1rem',
                        fontWeight: '600',
                        color: '#475569'
                      }}
                      title="Zoom Out"
                    >
                      −
                    </button>
                    <span style={{ fontSize: '0.875rem', fontWeight: '500', color: '#64748b', minWidth: '50px', textAlign: 'center' }}>
                      {Math.round(brochureZoom * 100)}%
                    </span>
                    <button
                      onClick={() => setBrochureZoom(prev => Math.min(3, prev + 0.25))}
                      style={{
                        background: '#f1f5f9',
                        border: '1px solid #cbd5e1',
                        borderRadius: '6px',
                        padding: '6px 12px',
                        cursor: 'pointer',
                        fontSize: '1rem',
                        fontWeight: '600',
                        color: '#475569'
                      }}
                      title="Zoom In"
                    >
                      +
                    </button>
                    <button
                      onClick={() => setBrochureZoom(1)}
                      style={{
                        background: '#f1f5f9',
                        border: '1px solid #cbd5e1',
                        borderRadius: '6px',
                        padding: '6px 12px',
                        cursor: 'pointer',
                        fontSize: '0.75rem',
                        fontWeight: '500',
                        color: '#475569'
                      }}
                      title="Reset Zoom"
                    >
                      Reset
                    </button>
                  </div>
                )}
                <button
                  onClick={() => { setShowBrochureModal(false); setBrochureZoom(1); }}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '1.5rem',
                    cursor: 'pointer',
                    color: '#64748b',
                    padding: '0',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px'
                  }}
                >
                  ×
                </button>
              </div>
            </div>
            <div style={{ padding: '20px', overflow: 'auto' }}>
              {brochurePreview && formData.brochure && (
                <div style={{ textAlign: 'center' }}>
                  {formData.brochure.type.startsWith('image/') ? (
                    <img
                      src={brochurePreview}
                      alt="Brochure"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '80vh',
                        objectFit: 'contain',
                        borderRadius: '8px',
                        transform: `scale(${brochureZoom})`,
                        transition: 'transform 0.2s ease',
                        cursor: brochureZoom > 1 ? 'move' : 'default'
                      }}
                    />
                  ) : formData.brochure.type === 'application/pdf' ? (
                    <iframe
                      src={brochurePreview}
                      style={{
                        width: '100%',
                        height: '80vh',
                        border: 'none',
                        borderRadius: '8px'
                      }}
                      title="PDF Preview"
                    />
                  ) : (formData.brochure.type.startsWith('text/') || /\.(edi|x12|txt|csv|xml|json)$/i.test(formData.brochure.name)) ? (
                    <div style={{
                      textAlign: 'left',
                      background: '#f8fafc',
                      padding: '20px',
                      borderRadius: '8px',
                      border: '1px solid #e2e8f0',
                      overflow: 'auto',
                      maxHeight: '75vh'
                    }}>
                      <pre style={{
                        margin: 0,
                        fontFamily: '"Cascadia Code", "Source Code Pro", Menlo, Monaco, Consolas, monospace',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-all',
                        fontSize: '0.85rem',
                        color: '#334155',
                        lineHeight: '1.5'
                      }}>
                        {brochureText || 'Loading content...'}
                      </pre>
                    </div>
                  ) : (
                    <div style={{
                      padding: '40px',
                      textAlign: 'center',
                      color: '#64748b'
                    }}>
                      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ margin: '0 auto 20px' }}>
                        <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                        <polyline points="13 2 13 9 20 9"></polyline>
                      </svg>
                      <p style={{ fontSize: '1.125rem', fontWeight: '500', marginBottom: '10px' }}>
                        File uploaded successfully
                      </p>
                      <p style={{ fontSize: '0.875rem' }}>
                        <strong>Filename:</strong> {formData.brochure.name}
                      </p>
                      <p style={{ fontSize: '0.875rem' }}>
                        <strong>Type:</strong> {formData.brochure.type || 'Unknown'}
                      </p>
                      <p style={{ fontSize: '0.875rem' }}>
                        <strong>Size:</strong> {(formData.brochure.size / 1024).toFixed(2)} KB
                      </p>
                      <p style={{ fontSize: '0.875rem', marginTop: '20px', color: '#94a3b8' }}>
                        Preview not available for this file type
                      </p>
                    </div>
                  )}
                  <div style={{ marginTop: '20px', fontSize: '0.875rem', color: '#64748b' }}>
                    <strong>File:</strong> {formData.brochure.name}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div >
  );
}
